// src/chains/index.js
import { ethereumConfig } from './ethereum';
import { bitrockConfig } from './bitrock';
import { baseConfig } from './base';
import { bscConfig } from './bsc';
import { arbitrumConfig } from './arbitrum';
import { avalancheConfig } from './avalanche';
import { polygonConfig } from './polygon';
import { infinaeonConfig } from './infinaeon';
import { omaxConfig } from './omax';
import { celoConfig } from './celo';
import { optimismConfig } from './optimism';
import { cronosConfig } from './cronos';
import { taraxaConfig} from './taraxa';


// Export all supported chains in an object keyed by chain.key
export const supportedChains = {
  bitrock: bitrockConfig,
  ethereum: ethereumConfig,
  base: baseConfig,
  bsc: bscConfig,
  arbitrum: arbitrumConfig,
  taraxa: taraxaConfig,
  avalanche: avalancheConfig,
  optimism: optimismConfig,
  polygon: polygonConfig,
  cronos: cronosConfig,
  celo: celoConfig,
  infinaeon: infinaeonConfig,
  // omax: omaxConfig,
  // Add new chains here
};

// Get array of chain objects (useful for UI components like network selector)
export const getChainList = () => {
  return Object.values(supportedChains);
};

// Get chain by chainId
export const getChainByChainId = (chainId) => {
  if (!chainId) return null;
  return Object.values(supportedChains).find(
    (chain) => chain.chainId === Number(chainId)
  );
};

// Get default chain
export const getDefaultChain = () => {
  return bitrockConfig; // Default to Bitrock
};
